import React, { useState, useEffect } from "react";
import { IconButton, Typography, Box } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { format, addMonths, getDaysInMonth } from "date-fns";

const MonthChange = ({ onMonthChange }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    updateMonthData(currentDate);
  }, []);

  const updateMonthData = (date) => {
    const days = getDaysInMonth(date);
    const formattedMonth = format(date, "yyyy-MM"); // Format as YYYY-MM
    onMonthChange(formattedMonth, days);
  };

  const handleMonthChange = (direction) => {
    const newDate = addMonths(currentDate, direction);
    setCurrentDate(newDate);
    updateMonthData(newDate);
  };

  return (
    <Box display="flex" alignItems="center">
      <IconButton onClick={() => handleMonthChange(-1)}>
        <ArrowBack />
      </IconButton>
      <Typography variant="subtitle1" sx={{ mx: 2 }}>
        {format(currentDate, "MMMM yyyy")}
      </Typography>
      <IconButton onClick={() => handleMonthChange(1)}>
        <ArrowForward />
      </IconButton>
    </Box>
  );
};

export default MonthChange;
